import { useState } from 'react';
import { SlidePanelProductInfoProps } from '.';
import { FinalFocusRef } from './SlidePanel';

export const useControlSlidePanel = (): {
  isOpen: boolean;
  productInfo: SlidePanelProductInfoProps;
  handleOnCloseSlidePanel: () => void;
  handleOnCardClick: (productInfo: SlidePanelProductInfoProps) => void;
} => {
  const [isOpen, setIsOpen] = useState(false);
  const [finalFocusRef, setFinalFocusRef] = useState<FinalFocusRef>();
  const [productInfo, setProductInfo] = useState<SlidePanelProductInfoProps>(
    {} as SlidePanelProductInfoProps,
  );

  const handleOnCardClick = (productInfo) => {
    const { finalFocusRef, ...rest } = productInfo;
    setIsOpen(true);
    setFinalFocusRef(finalFocusRef);
    setProductInfo(rest);
  };
  const handleOnCloseSlidePanel = () => {
    finalFocusRef?.current?.focus();
    return setIsOpen(false);
  };

  return { isOpen, handleOnCloseSlidePanel, productInfo, handleOnCardClick };
};
